import React, { useEffect, useState } from "react";
import baseUrl from "../../../../api/baseUrl";
import BottomTab from "../../../../components/pagination/BottomTab";
export const DOCTPOR_APPOINT = [
  { name: "Dr. David Max", number: "02", det: "Appointments" },
  { name: "Dr. David Max", number: "02", det: "Appointments" },
  { name: "Dr. David Max", number: "02", det: "Appointments" },
  { name: "Dr. David Max", number: "02", det: "Appointments" },
  { name: "Dr. David Max", number: "02", det: "Appointments" },
  { name: "Dr. David Max", number: "02", det: "Appointments" },
];
function UpcommingTable() {
  const [appointments, setappointments] = useState([]);
  const [count, setcount] = useState(0);
  const [page, setpage] = useState(1);
  const getdata = (pages: any) => {
    baseUrl
      .get("dashboard/upcommingAppointment", {
        headers: {
          page: pages,
        },
      })
      .then((response) => {
        setappointments(response.data.data);
        setcount(response.data.count);
      })
      .catch((error) => {
        console.error(error.response);
      });
  };
  useEffect(() => {
    getdata(page);
  }, []);
  const onPageChange = (e: any) => {
    getdata(e);
    setpage(e);
  };
  return (
    <div className={"table_upcoming"}>
      <h3 className={"table_heading"}>Upcoming Appointment</h3>
      <div className="tableContainer">
      <table>
        <thead>
          <tr>
            <th>Patient Name</th>
            <th>Date</th>
            <th>Time</th>
            <th>Contact</th>
            <th>Dentist</th>
          </tr>
        </thead>
        <tbody>
          {appointments?.map((item: any, index: number) => (
            <tr key={index} tabIndex={-1}>
              <th>{item?.patientId?.fullName}</th>
              <td>{item?.date.split("T")[0]}</td>
              <td>{item?.startTime}</td>
              <td>{item?.patientId?.mobileNo}</td>
              <td>
                {item?.doctorId?.firstName} {item?.doctorId?.lastName}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <BottomTab title={"Appointments"} count={count} onPageChange={onPageChange} />
      </div>
    </div>
  );
}

export default UpcommingTable;
